import { HttpClient } from '@opallabs/api'
import loadGlobalSearchResults from '../loadGlobalSearchResults'

export const fetchSearchResults = (params) =>
  HttpClient().get(
    `/api/v1/search?query=${params.searchTerm}&slug=${params.slug}&brand_id=${params.workspaceId}`
  )

const getGlobalSearchResults = (params) => (dispatch) =>
  fetchSearchResults(params)
    .then((response) => {
      const resp = response.data.data
      const results = resp.map((item) => {
        const title = item.title || item.fullName
        return { ...item, title }
      })
      return results
    })
    .then((results) => dispatch(loadGlobalSearchResults(results)))
    .catch((err) => {
      console.error(err)
      throw err
    })

export default getGlobalSearchResults
